// Empty state component for applications list
// Shown when user has no applications

import type { ReactNode } from 'react';

interface EmptyStateProps {
  title?: string;
  description: string;
  illustration?: ReactNode;
  action?: ReactNode;
}

// Default illustration - question mark figure (from Figma)
function DefaultIllustration() {
  return (
    <div className="w-48 h-48 mx-auto mb-4">
      <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Person figure */}
        <circle cx="80" cy="100" r="20" fill="#93C5FD" />
        <rect x="60" y="120" width="40" height="50" rx="8" fill="#93C5FD" />
        {/* Question mark */}
        <text x="130" y="140" fontSize="80" fill="#FCD34D" fontWeight="bold">
          ?
        </text>
      </svg>
    </div>
  );
}

export function EmptyState({ title, description, illustration, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center pt-20 px-4 text-center">
      {illustration || <DefaultIllustration />}
      {title && <p className="text-md text-[#939393] max-w-md mb-1">{title}</p>}
      <p className="text-md text-[#939393] max-w-md mb-6">{description}</p>
      {action}
    </div>
  );
}
